/* eslint-disable */
import * as registry from '../registry.js'
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Floor_CountInputs */



/**
* | countPlural | output |
* | --- | --- |
* | "one" | "floor" |
* | "other" | "floors" |
*
* @param {Floor_CountInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const floor_count = /** @type {((inputs: Floor_CountInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Floor_CountInputs, { locale?: "fr" | "en" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") {
		const countPlural = registry.plural("en", i?.count, {}, true);
		if (countPlural === "one") return /** @type {LocalizedString} */ (`floor`);
		if (countPlural === "other") return /** @type {LocalizedString} */ (`floors`);
		return /** @type {LocalizedString} */ ("floor_count");
	}
	{
		const countPlural = registry.plural("fr", i?.count, {}, true);
		if (countPlural === "one") return /** @type {LocalizedString} */ (`niveau`);
		if (countPlural === "other") return /** @type {LocalizedString} */ (`niveaux`);
		return /** @type {LocalizedString} */ ("floor_count");
	}
});